import _classnames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const FormGroup = React.memo(
  ({ children, classes, helpText, label, labelFor, labelInfo, status }) => (
    <div
      className={_classnames('FormGroup', classes, {
        [`FormGroup--${status}`]: !!status,
      })}
    >
      {label && (
        <label className="FormGroup__label" htmlFor={labelFor}>
          {label} <span className="FormGroup__label-info">{labelInfo}</span>
        </label>
      )}
      <div className="FormGroup__content">
        {children}
        {helpText && <div className="FormGroup__help-text">{helpText}</div>}
      </div>
    </div>
  )
);

FormGroup.propTypes = {
  /**
   * Children to render
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  classes: PropTypes.string,
  helpText: PropTypes.string,
  label: PropTypes.string,
  labelFor: PropTypes.string,
  labelInfo: PropTypes.string,
  status: PropTypes.oneOf(['success', 'warning']),
};

FormGroup.defaultProps = {
  children: undefined,
  classes: '',
  helpText: null,
  label: null,
  labelFor: null,
  labelInfo: null,
  status: null,
};

/**
 * @type {React.ComponentType<any>}
 */
export default FormGroup;
